import React from 'react';
import { useDispatch } from 'react-redux';

import { Modal, Button } from 'hosman-material';

import { updateNewPhotoMeetingModalOpen } from '../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const NewPhotoMeetingModal = ({ setIsClosing }) => {
  const dispatch = useDispatch();

  return (
    <Modal isOpen>
      <div className='flex flex-col gap-6 p-6 text-center'>
        <p>Voulez-vous vraiment fermer cette fenêtre ?</p>
        <p>Les modifications non enregistrées seront perdues.</p>
        
        <div className='flex flex-col md:flex-row justify-center gap-3'>
          <Button label='Annuler' type='tertiary' onClick={() => setIsClosing(false)} />
          <Button label='Oui, fermer' onClick={() => dispatch(updateNewPhotoMeetingModalOpen(false))} />
        </div>
      </div>
    </Modal>
  )
}

export default NewPhotoMeetingModal;
